// Recovered compiled webpack factory 7183. Edit this function expression; run npm run build.
(e) => {
  e.exports = {
    style: {
      fontFamily:
        "'GeistMono', ui-monospace, SFMono-Regular, Roboto Mono, Menlo, Monaco, Liberation Mono, DejaVu Sans Mono, Courier New, monospace",
    },
    className: "__className_46451f",
    variable: "__variable_46451f",
  };
}
